export const vendorsConstants = {
  GET_VENDORS: 'GET_VENDORS',
  STORE_BATCH_VENDORS: 'STORE_BATCH_VENDORS',
  CLEAR_VENDORS: 'CLEAR_VENDORS',
};
